export const questions = [
  {
    questionText: "Qaysi usul konservalashning mikrobiologik turiga kiradi?",
    answerOptions: [
      { id: 1, answerText: "tuzlash, vinochilik", isCorrect: true },
      { id: 2, answerText: "sterilizatsiya, quritish", isCorrect: false },
      { id: 3, answerText: "sirkalash, sulfitlash", isCorrect: false, },
      { id: 4, answerText: "pasterilizatsiya, muzlatish", isCorrect: false },
    ],
  },
  {
    questionText: "Кonservalash necha xil bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "Mikrobiologik va fizik", isCorrect: false },
      { id: 2, answerText: "Mikrobiologik", isCorrect: false },
      { id: 3, answerText: "Кimyoviy, fizik va mikrobiologik ", isCorrect: true, },
      { id: 4, answerText: "Кimyoviy va fizik", isCorrect: false },
    ],
  },
  {
    questionText: "Mikrobiologik konservalash nimaga asoslanadi?",
    answerOptions: [
      { id: 1, answerText: "Foydali mikroorganizmlar faoliyatini to’xtatishga ", isCorrect: false },
      { id: 2, answerText: "Foydali mikroorganizmlar faoliyatini rag’batlantirishga", isCorrect: true },
      { id: 3, answerText: "Sterilizasiya qilishga", isCorrect: false, },
      { id: 4, answerText: "Pasterizasiya qilishga", isCorrect: false },
    ],
  },
  {
    questionText: "Кimyoviy konservalash nimaga asoslanadi? ",
    answerOptions: [
      { id: 1, answerText: "Pasterizasiya qilishga", isCorrect: false },
      { id: 2, answerText: "Sterilizasiya qilishga", isCorrect: false },
      { id: 3, answerText: "Nur bilan mikroorganizmlar faoliyatini to’xtatishga", isCorrect: false, },
      { id: 4, answerText: "Кimyoviy moddalar ta’sirida mikroorganizmlar faoliyatini to’xtatishga", isCorrect: true },
    ],
  },
  {
    questionText: "Fizik konservalash nimaga asoslanadi?",
    answerOptions: [
      { id: 1, answerText: "Spirt bilan mikroorganizmlar faoliyatini to’xtatishga", isCorrect: false },
      { id: 2, answerText: "Fizik kattaliklar ta’sirida mikroorganizmlar faoliyatini to’xtatishga", isCorrect: true },
      { id: 3, answerText: "Foydali mikroorganizmlar faoliyatini rag’batlantirishga ", isCorrect: false, },
      { id: 4, answerText: "Benzoy kislotasi bilan mikroorganizmlar faoliyatini to’xtatishga", isCorrect: false },
    ],
  },
  {
    questionText: " Qaysi mahsulot qirg’ich yoki elakdan yaxshilab o’tkazilib shakarli siropda qaynatib tayyorlanadi?",
    answerOptions: [
      { id: 1, answerText: "murabbo", isCorrect: false },
      { id: 2, answerText: " kompot", isCorrect: false },
      { id: 3, answerText: " jem", isCorrect: true, },
      { id: 4, answerText: "povidlo", isCorrect: false },
    ],
  },
  {
    questionText: "Tomat sharbatini sterillash uchun bankalar suvli qozonda necha daqiqa blanshirlanadi?",
    answerOptions: [
      { id: 1, answerText: "10-15", isCorrect: true },
      { id: 2, answerText: "20-25", isCorrect: false },
      { id: 3, answerText: "20-30", isCorrect: false, },
      { id: 4, answerText: "35-40", isCorrect: false },
    ],
  },
  {
    questionText: "Marinad nima?",
    answerOptions: [
      { id: 1, answerText: "Butunligicha konservalangan sabzavotlar", isCorrect: false },
      { id: 2, answerText: "Sirka kislotasi, tuz va shakar bilan konservalangan sabzavot ", isCorrect: true },
      { id: 3, answerText: "Tuzlangan sabzavotlar", isCorrect: false, },
      { id: 4, answerText: "Sabzavot ikralari", isCorrect: false },
    ],
  },
  {
    questionText: "Tuzlangan qizil pomidorda tuz miqdori necha foizdan oshmasligi lozim?",
    answerOptions: [
      { id: 1, answerText: "7-8", isCorrect: false },
      { id: 2, answerText: "6-7", isCorrect: false },
      { id: 3, answerText: "1-2", isCorrect: false, },
      { id: 4, answerText: "3-6", isCorrect: true },
    ],
  },
  {
    questionText: "Кaram tuzlashda eng yaxshi idish qaysi?",
    answerOptions: [
      { id: 1, answerText: "Shisha banka ", isCorrect: false },
      { id: 2, answerText: "Yog’och bochka ", isCorrect: true },
      { id: 3, answerText: "Plastmassa sisterna", isCorrect: false, },
      { id: 4, answerText: "Metall sisterna", isCorrect: false },
    ],
  },
  {
    questionText: "Karam tuzlashda sabzi va osh tuzining konsentratsiyasi qancha bo‘lishi kerak?",
    answerOptions: [
      { id: 1, answerText: "Sabzi-2%, osh tuzi – 2-2,5%", isCorrect: false },
      { id: 2, answerText: "Sabzi-3%, osh tuzi – 1,8-2,2%", isCorrect: false },
      { id: 3, answerText: "Sabzi-2%, osh tuzi – 1,5-2%", isCorrect: false, },
      { id: 4, answerText: "Sabzi-3%, osh tuzi – 1,8-2%", isCorrect: true },
    ],
  },
  {
    questionText: "Karam tuzlash jarayonida eng qulay havo harorati qancha bo‘lishi kerak?",
    answerOptions: [
      { id: 1, answerText: "16-20°C", isCorrect: true },
      { id: 2, answerText: "15-18°C", isCorrect: false },
      { id: 3, answerText: "20-25°C ", isCorrect: false, },
      { id: 4, answerText: "18-25°C", isCorrect: false },
    ],
  },
  {
    questionText: "Mayda bodringlarni tuzlashda qancha foiz tuz ishlatiladi?",
    answerOptions: [
      { id: 1, answerText: "6-8 % ", isCorrect: false },
      { id: 2, answerText: "5-6 %", isCorrect: false },
      { id: 3, answerText: "8-9 %", isCorrect: true, },
      { id: 4, answerText: "3-4 %", isCorrect: false },
    ],
  },
  {
    questionText: "Pasterizatsiya nima?",
    answerOptions: [
      { id: 1, answerText: "130 daraja issiqlik bilan ishlov berish", isCorrect: false },
      { id: 2, answerText: "100 °S dan past daraja  issiqlik ishlov berish", isCorrect: true },
      { id: 3, answerText: "120 daraja issiqlik bilan ishlov berish", isCorrect: false, },
      { id: 4, answerText: "140 daraja issiqlik bilan ishlov berish", isCorrect: false },
    ],
  },
  {
    questionText: "Sterilizatsiya nima?",
    answerOptions: [
      { id: 1, answerText: "85 daraja issiqlik bilan ishlov berish", isCorrect: false },
      { id: 2, answerText: "75 daraja issiqlik bilan ishlov berish", isCorrect: false },
      { id: 3, answerText: "90 daraja issiqlik bilan ishlov berish", isCorrect: false, },
      { id: 4, answerText: "100 darajadan yuqori issiqlik bilan ishlov berish ", isCorrect: true },
    ],
  },
  {
    questionText: "Konservalarni qanday sharoitda saqlash tavsiya etiladi?",
    answerOptions: [
      { id: 1, answerText: "15°C haroratda va 75% nisbiy namlikda", isCorrect: true },
      { id: 2, answerText: "25°C haroratda va 55% nisbiy namlikda", isCorrect: false },
      { id: 3, answerText: "35°C haroratda va 85% nisbiy namlikda", isCorrect: false, },
      { id: 4, answerText: "15°C haroratda va 95% nisbiy namlikda", isCorrect: false },
    ],
  },
  {
    questionText: "Havoning nisbiy namligini aniqlaydigan asbob nima?",
    answerOptions: [
      { id: 1, answerText: "kriometr", isCorrect: false },
      { id: 2, answerText: "psixometr", isCorrect: true },
      { id: 3, answerText: "termometr", isCorrect: false, },
      { id: 4, answerText: " refraktometr", isCorrect: false },
    ],
  },
  {
    questionText: "Kompotlarni pasterizatsiya qilishda qanday asbobdan foydalaniladi?",
    answerOptions: [
      { id: 1, answerText: "avtoklav", isCorrect: true },
      { id: 2, answerText: "xromatografiya", isCorrect: false },
      { id: 3, answerText: "refraktometr", isCorrect: false, },
      { id: 4, answerText: "distilyator", isCorrect: false },
    ],
  },
  {
    questionText: "Аsseptik qadoqlash qaysi mahsulotlarga qo'llaniladi?",
    answerOptions: [
      { id: 1, answerText: "suvga", isCorrect: false },
      { id: 2, answerText: "Sochiluvchan mahsulotlarga", isCorrect: false },
      { id: 3, answerText: "sharbatlarga", isCorrect: true, },
      { id: 4, answerText: "toʼkiluvchan mahsulotlarga", isCorrect: false },
    ],
  },
  {
    questionText: "Аsseptik qadoqlash  qaysi idishlarga oʼtkaziladi?",
    answerOptions: [
      { id: 1, answerText: "polietelen", isCorrect: false },
      { id: 2, answerText: "metal", isCorrect: false },
      { id: 3, answerText: "shisha", isCorrect: false, },
      { id: 4, answerText: "qogʼoz idishlarga", isCorrect: true },
    ],
  },
  {
    questionText: "Аsseptik qadoqlash nima?",
    answerOptions: [
      { id: 1, answerText: "birdaniga sovutish", isCorrect: false },
      { id: 2, answerText: "pasterizatsiyadan keyin birdaniga qizdirish", isCorrect: false },
      { id: 3, answerText: "pasterizatsiyadan keyin birdaniga sovutish", isCorrect: true, },
      { id: 4, answerText: "pasterizatsiyadan keyin qadoqlash", isCorrect: false },
    ],
  },
  {
    questionText: ". Dezinseksiya qilish deganda nima tushuniladi?",
    answerOptions: [
      { id: 1, answerText: "Zararkunandalarga qarshi kurash", isCorrect: true },
      { id: 2, answerText: "Sanitar rejimga amal qilish", isCorrect: false },
      { id: 3, answerText: "kemiruvchilarga qarshi kurashish", isCorrect: false, },
      { id: 4, answerText: "Mikroorganizmlarga qarshikurash", isCorrect: false },
    ],
  },
  {
    questionText: "Deratizatsiya qilish deganda nima tushuniladi?",
    answerOptions: [
      { id: 1, answerText: "Zararkunandalarga qarshi kurash", isCorrect: false },
      { id: 2, answerText: "kemiruvchilarga qarshi kurashish", isCorrect: true },
      { id: 3, answerText: "Mikroorganizmlar bilan kurashish", isCorrect: false, },
      { id: 4, answerText: "Sanitar rejimga amal qilish", isCorrect: false },
    ],
  },
  {
    questionText: "Yozgi muddatda sabzavotlarni qanday usullarda saqlanadi?",
    answerOptions: [
      { id: 1, answerText: "Jadal muzlatib, faol shamollatib, vakuum usullarida", isCorrect: true },
      { id: 2, answerText: "Faqatgina jadal muzlatib", isCorrect: false },
      { id: 3, answerText: "Yozda sabzavot saqlanmaydi", isCorrect: false, },
      { id: 4, answerText: "Vakum usullarida", isCorrect: false },
    ],
  },
  {
    questionText: "Ishlab chiqarishda mahsulotlarni chirigan va kasallanganlaridan tozalash nima deyiladi?",
    answerOptions: [
      { id: 1, answerText: "sortirovka", isCorrect: false },
      { id: 2, answerText: "markirofkavka", isCorrect: false },
      { id: 3, answerText: "kolibrovka", isCorrect: false, },
      { id: 4, answerText: "inspeksiya", isCorrect: true },
    ],
  },
  {
    questionText: "Qaysi yetilish darajasida sabzavotlar yigʼib-terib olishga kirishiladi?",
    answerOptions: [
      { id: 1, answerText: "biokimyoviy yetilganda", isCorrect: false },
      { id: 2, answerText: "fizikaviy yetilganda", isCorrect: false },
      { id: 3, answerText: "Texnik etilganda", isCorrect: true, },
      { id: 4, answerText: "terimbop pishib yetilganda", isCorrect: false },
    ],
  },
  {
    questionText: "Qayta ishlashda marinad aralashmasi tayyorlashda necha foiz sirka kislotasi ishlatiladi?",
    answerOptions: [
      { id: 1, answerText: "0,4-0,6", isCorrect: false },
      { id: 2, answerText: "1,2-1,8", isCorrect: false },
      { id: 3, answerText: "0,6-0,9", isCorrect: true, },
      { id: 4, answerText: "1,0-1,2", isCorrect: false },
    ],
  },
  {
    questionText: "Qishda olma mevalarini omborxonada saqlashda havo harorati va nisbiy namligi qanday boʼladi?",
    answerOptions: [
      { id: 1, answerText: "7-8 °S, 65-70% ", isCorrect: false },
      { id: 2, answerText: "0,5-1,5 °S 90-95%", isCorrect: true },
      { id: 3, answerText: "8-10 °S, 75-80%", isCorrect: false, },
      { id: 4, answerText: "4-6 °S, 90-95%", isCorrect: false },
    ],
  },
  {
    questionText: "Qishloq xoʼjaligi mahsulotlari sifatiga taʼsir koʼrsatadigan omillar qaysilar?",
    answerOptions: [
      { id: 1, answerText: "texnologik, fizik, kimyoviy  ", isCorrect: false },
      { id: 2, answerText: "geografik, fizik, biologik", isCorrect: false },
      { id: 3, answerText: "geografik, biologik, fizik", isCorrect: false, },
      { id: 4, answerText: "geografik, texnologik, biologik", isCorrect: true },
    ],
  },
  {
    questionText: "Qishloq xoʼjaligi mahsulotlarini qadoqlashning asosiy maqsadi nima?",
    answerOptions: [
      { id: 1, answerText: "Mahsulotlarni tashqi koʼrinishini saqlab qolish", isCorrect: false },
      { id: 2, answerText: "Yangi uzib olingan yoki tayyorlangan mahsulot sifat koʼsatkichlarini saqlab qolish", isCorrect: true },
      { id: 3, answerText: "Mahsulotni uzoq muddatga saqlash", isCorrect: false, },
      { id: 4, answerText: "Mahsulotlarga tovar ishlov berish", isCorrect: false },
    ],
  },
  {
    questionText: "Mahsulotlarni kolibrlash deganda nimani tushunasiz?",
    answerOptions: [
      { id: 1, answerText: "Turi boʼicha saralash", isCorrect: false },
      { id: 2, answerText: "Navi boʼyicha saralash", isCorrect: false },
      { id: 3, answerText: "Oʼlchami boʼyicha saralash", isCorrect: true, },
      { id: 4, answerText: "Rangi boʼyicha saralash", isCorrect: false },
    ],
  },
  {
    questionText: "Mevalardan kompot olishda qand qiyomining qanday kontsentratsiyasi ishlatiladi (%)?",
    answerOptions: [
      { id: 1, answerText: "65", isCorrect: true },
      { id: 2, answerText: "30", isCorrect: false },
      { id: 3, answerText: "50", isCorrect: false, },
      { id: 4, answerText: "80", isCorrect: false },
    ],
  },
  {
    questionText: "Mevalarning fiziologik yetilishi deganda nimani tushunasiz?",
    answerOptions: [
      { id: 1, answerText: "barglari sargayishi va zarur moddalarni toʼplanishi", isCorrect: false },
      { id: 2, answerText: "biokimyoviy jihatdan urugʼlari tala yetilishi va zarur oziqa moddalarni toʼplanishi.", isCorrect: true },
      { id: 3, answerText: "biokimyoviy, fizikaviy va biologik yetilishi", isCorrect: false, },
      { id: 4, answerText: "biokimyoviy, fizikaviy va zarur moddalarni toʼplanishi.", isCorrect: false },
    ],
  },
  {
    questionText: "Meva-uzumlarning texnik yetilishi deganda nimani tushunasiz?",
    answerOptions: [
      { id: 1, answerText: "meva-uzumlarning biologik, fizik holatiga qarab belgilanadi.", isCorrect: false },
      { id: 2, answerText: "meva-uzumlarning bozorbopligi", isCorrect: false },
      { id: 3, answerText: "mevalarni biokimyoviy yetilishi", isCorrect: false, },
      { id: 4, answerText: "meva-uzumlarning holatiga qarab belgilanadi.", isCorrect: true },
    ],
  },
  {
    questionText: "Odatda oʼrta hajmdagi yangi bodringlarni tuzlashda qanday nomokop quvvati moʼljallanadi (%)?",
    answerOptions: [
      { id: 1, answerText: "0,4-0,5 ", isCorrect: false },
      { id: 2, answerText: "0,9-1 ", isCorrect: false },
      { id: 3, answerText: "10-15", isCorrect: false, },
      { id: 4, answerText: "0,7-0,8", isCorrect: true },
    ],
  },
  {
    questionText: "Sensorik baho berish qadimiy usulini koʼrsating",
    answerOptions: [
      { id: 1, answerText: "Chamalash", isCorrect: false },
      { id: 2, answerText: "Hisob-kitob yoʼli bilan baholash", isCorrect: false },
      { id: 3, answerText: "Isteʼmolchi munosabati omiliga asoslangan usuli", isCorrect: true },
      { id: 4, answerText: "Laboratoriyada tahlil qilish", isCorrect: false },
    ],
  },
  {
    questionText: "Tavsiya etilgan har bir kishi yiliga isteʼmol qilishi lozim boʼlgan kartoshka meʼyori qancha, kg?",
    answerOptions: [
      { id: 1, answerText: "55", isCorrect: false },
      { id: 2, answerText: "45", isCorrect: true },
      { id: 3, answerText: "25", isCorrect: false },
      { id: 4, answerText: "60", isCorrect: false },
    ],
  },
  {
    questionText: "Talab boʼyicha karamning oʼrtacha hajm ogʼirligi qancha (kg/m3)?",
    answerOptions: [
      { id: 1, answerText: "400-450", isCorrect: true },
      { id: 2, answerText: "500-600", isCorrect: false },
      { id: 3, answerText: "800-900", isCorrect: false },
      { id: 4, answerText: "200-250", isCorrect: false },
    ],
  },
  {
    questionText: "Qishloq xoʼjaligi mahsulotlari sifatini baholash tizimi qanday nomlanadi?",
    answerOptions: [
      { id: 1, answerText: "Hisoblash tizimi", isCorrect: false },
      { id: 2, answerText: "Jamlash tizimi", isCorrect: false },
      { id: 3, answerText: "Konditsiyalash tizimi", isCorrect: true },
      { id: 4, answerText: "Baholash tizimi", isCorrect: false },
    ],
  },
  {
    questionText: "Qishloq xoʼjaligida nechta konditsiyalar ishlatiladi?",
    answerOptions: [
      { id: 1, answerText: "4", isCorrect: true },
      { id: 2, answerText: "6", isCorrect: false },
      { id: 3, answerText: "7", isCorrect: false },
      { id: 4, answerText: "5", isCorrect: false },
    ],
  },
  {
    questionText: "Unifikatsiya nima?",
    answerOptions: [
      { id: 1, answerText: "Bir xillashtirish", isCorrect: true },
      { id: 2, answerText: "Unday atama yo'q", isCorrect: false },
      { id: 3, answerText: "Har xillashtirish", isCorrect: false },
      { id: 4, answerText: "Brakka chiqarish", isCorrect: false },
    ],
  },
  {
    questionText: "Oʼrtacha namuna va asosiy namunaning farqi nimada?",
    answerOptions: [
      { id: 1, answerText: "Oʼrtacha namuna asosiy namunadan olinadi", isCorrect: true },
      { id: 2, answerText: "Аsosiy namuna oʼrtacha namunadan olinadi", isCorrect: false },
      { id: 3, answerText: "Namunalarning namligi bir-biridan farq qiladi", isCorrect: false },
      { id: 4, answerText: "Ikkalasining bir-biridan farqi yo'q", isCorrect: false },
    ],
  },
  {
    questionText: "Qishloq xoʼjaligi mahsulotlarini saqlashning innovatsion usulini koʼrsating.",
    answerOptions: [
      { id: 1, answerText: "Uyum qilib saqlash", isCorrect: false },
      { id: 2, answerText: "Nanotexnologiyalarni qoʼllash", isCorrect: true },
      { id: 3, answerText: "Dudlab saqlash", isCorrect: false },
      { id: 4, answerText: "Аyvonda saqlash", isCorrect: false },
    ],
  },
  {
    questionText: "Qishloq xoʼjaligi mahsulotlarini saqlashning zamonaviy usulini koʼrsating.",
    answerOptions: [
      { id: 1, answerText: "Oltingugurt angidridi bilan saqlash", isCorrect: false },
      { id: 2, answerText: "Konservalab saqlash", isCorrect: false },
      { id: 3, answerText: "Lahzada muzlatish", isCorrect: true },
      { id: 4, answerText: "Muzlatkichda saqlash", isCorrect: false },
    ],
  },
  {
    questionText: "Shtrixli kodlashtirish boʼyicha Oʼzbekistonning identifikatsion raqamini koʼrsating.",
    answerOptions: [
      { id: 1, answerText: "458", isCorrect: false },
      { id: 2, answerText: "478", isCorrect: true },
      { id: 3, answerText: "482", isCorrect: false },
      { id: 4, answerText: "479", isCorrect: false },
    ],
  },
  {
    questionText: "N. V. Vavilov sabzavotlarning kelib chiqish makonlarini necha markazga ajratgan?",
    answerOptions: [
      { id: 1, answerText: "7 ta", isCorrect: true },
      { id: 2, answerText: "11 ta", isCorrect: false },
      { id: 3, answerText: "8 ta", isCorrect: false },
      { id: 4, answerText: "5 ta", isCorrect: false },
    ],
  },
  {
    questionText: "O‘zbekistonda sabzavot va poliz qancha maydonni tashkil etmoqda.",
    answerOptions: [
      { id: 1, answerText: "243,5 ming gektarni yoki 5,7%", isCorrect: true },
      { id: 2, answerText: "288,5 ming gektarni yoki 8,7%", isCorrect: false },
      { id: 3, answerText: "254,5 ming gektarni yoki 6,5%", isCorrect: false },
      { id: 4, answerText: "273,5 ming gektarni yoki 7,7%", isCorrect: false },
    ],
  },
  {
    questionText: "Xantal (salat gorchisa), bryukva, xren, qatron qaysi botanik oilaga mansub?",
    answerOptions: [
      { id: 1, answerText: "Murakkabguldoshlar", isCorrect: false },
      { id: 2, answerText: "Sho‘radoshlar", isCorrect: false },
      { id: 3, answerText: "Karamdoshlar", isCorrect: true },
      { id: 4, answerText: "Toronguldoshlar", isCorrect: false },
    ],
  },
  {
    questionText: "Sabzavotlarning dunyoda nechta turi mavjud.",
    answerOptions: [
      { id: 1, answerText: "2000", isCorrect: false },
      { id: 2, answerText: "1300", isCorrect: false },
      { id: 3, answerText: "1500", isCorrect: false },
      { id: 4, answerText: "1200", isCorrect: true },
    ],
  },
  {
    questionText: "Ko‘kat sabzavotlari qaysi qimmatli xo‘jalik belgisi bilan qadrlanadi?",
    answerOptions: [
      { id: 1, answerText: "moy va uglevodga boyligi bilan", isCorrect: false },
      { id: 2, answerText: "oqsil va moyga boyligi bilan", isCorrect: false },
      { id: 3, answerText: "vitamin va aminokeslotalarga boyligi bilan", isCorrect: true },
      { id: 4, answerText: "uglevod va oqsilga boyligi bilan", isCorrect: false },
    ],
  },
  {
    questionText: "Sabzavotlar tarkibida inson salomatligi uchun zarur bo‘lgan vitaminlarni nechtasi mavjud.",
    answerOptions: [
      { id: 1, answerText: "25 ta", isCorrect: false },
      { id: 2, answerText: "20 ta", isCorrect: false },
      { id: 3, answerText: "30 ta", isCorrect: false },
      { id: 4, answerText: "15 ta", isCorrect: true },
    ],
  },
  {
    questionText: "O‘zbekistonda qancha gektar sug‘oriladigan maydonlar mavjud.",
    answerOptions: [
      { id: 1, answerText: "5,5 mln", isCorrect: false },
      { id: 2, answerText: "4,8 mln", isCorrect: false },
      { id: 3, answerText: "5,5 mln", isCorrect: false },
      { id: 4, answerText: "4,3 mln", isCorrect: true },
    ],
  },
  {
    questionText: "Sabzavotlar deb nimaga aytiladi?",
    answerOptions: [
      { id: 1, answerText: "Bir yillik, ko‘p yillik va 10 yillik o‘simliklarga", isCorrect: false },
      { id: 2, answerText: "Sersuv mevasi em xashaksifatida ishlatiladiganlarga", isCorrect: false },
      { id: 3, answerText: "Sersuv mevasi va etli qismi oziq-ovqatga ishlatiladigan bir yillik, ikki yillik va ko‘p yillik o‘tchil o‘simliklarga.", isCorrect: true },
      { id: 4, answerText: "Sersuv mevasi va etli qismi kulinariyada ishlatiladiganlarga", isCorrect: false },
    ],
  },
  {
    questionText: "Bir inson yil mobaynida necha kg sabzavot iste’mol qilishi tavsiya etilgan?",
    answerOptions: [
      { id: 1, answerText: "113", isCorrect: true },
      { id: 2, answerText: "125", isCorrect: false },
      { id: 3, answerText: "200", isCorrect: false },
      { id: 4, answerText: "150", isCorrect: false },
    ],
  },
  {
    questionText: "Havo tarkibida necha % kislorod, azot va CO2 gazi mavjud?",
    answerOptions: [
      { id: 1, answerText: "21 % kislorod, azot 78% va CO2 gazi 0,03 mavjud", isCorrect: true },
      { id: 2, answerText: "30 % kislorod, azot 69% va CO2 gazi 0,10 mavjud", isCorrect: false },
      { id: 3, answerText: "25 % kislorod, azot 74% va CO2 gazi 0,05 mavjud", isCorrect: false },
      { id: 4, answerText: "35 % kislorod, azot 64% va CO2 gazi 0,20 mavjud", isCorrect: false },
    ],
  },
  {
    questionText: "Doimiy omborlar sharoit yaratilganiga qarab necha guruxga bo‘linadi?",
    answerOptions: [
      { id: 1, answerText: "8 ga", isCorrect: false },
      { id: 2, answerText: "3 ga", isCorrect: false },
      { id: 3, answerText: "7 ga", isCorrect: false },
      { id: 4, answerText: "5 ga", isCorrect: true },
    ],
  },
  {
    questionText: "Kartoshka tarkibidagi solanin qanday modda?",
    answerOptions: [
      { id: 1, answerText: "kartoshka tarkibidagi zaxarli modda", isCorrect: true },
      { id: 2, answerText: "Kartoshka kraxmalining izomeri", isCorrect: false },
      { id: 3, answerText: "Kartoshka tarkibidagi shirin modda", isCorrect: false },
      { id: 4, answerText: "Kartoshka tarkibidagi vitamin turi", isCorrect: false },
    ],
  },
  {
    questionText: "Karam tuzlashda sabzi va osh tuzining konsentratsiyasi qancha bo‘lishi kerak?",
    answerOptions: [
      { id: 1, answerText: "Sabzi-8%, osh tuzi – 8-9 %", isCorrect: false },
      { id: 2, answerText: "Sabzi-3%, osh tuzi – 1,8-2,5%", isCorrect: true },
      { id: 3, answerText: "Sabzi-5%, osh tuzi – 5-6 %", isCorrect: false },
      { id: 4, answerText: "Sabzi-7%, osh tuzi – 4-5%", isCorrect: false },
    ],
  },
  {
    questionText: "Sabzavotlarni tuzlash jarayonida eng qulay havo harorati qancha bo‘lishi kerak?",
    answerOptions: [
      { id: 1, answerText: "20-25°C", isCorrect: false },
      { id: 2, answerText: "25-30°C", isCorrect: false },
      { id: 3, answerText: "16-20°C", isCorrect: true },
      { id: 4, answerText: "30-35°C", isCorrect: false },
    ],
  },
  {
    questionText: "Konserva mahsulotlarni qanday sharoitda saqlash tavsiya etiladi?",
    answerOptions: [
      { id: 1, answerText: "30-35°C haroratda va 85% nisbiy namlikda", isCorrect: false },
      { id: 2, answerText: "10-15°C haroratda va 75% nisbiy namlikda", isCorrect: true },
      { id: 3, answerText: "25-30°C haroratda va 80% nisbiy namlikda", isCorrect: false },
      { id: 4, answerText: "35-40°C haroratda va 95% nisbiy namlikda", isCorrect: false },
    ],
  },
  {
    questionText: "Mahsulotlarni kolibrlash deganda nimani tushunasiz?",
    answerOptions: [
      { id: 1, answerText: "Rangi boʼyicha saralash", isCorrect: false },
      { id: 2, answerText: "Navi boʼyicha saralash", isCorrect: false },
      { id: 3, answerText: "Oʼlchami boʼyicha saralash", isCorrect: true },
      { id: 4, answerText: "Turi boʼyicha saralash", isCorrect: false },
    ],
  },
  {
    questionText: "Qadoqlashning asosiy maqsadi nima?",
    answerOptions: [
      { id: 1, answerText: "Mahsulotlarga tovar ishlov berish", isCorrect: false },
      { id: 2, answerText: "Mahsulotni uzoq muddatga saqlash", isCorrect: false },
      { id: 3, answerText: "Mahsulot sifat koʼrsatkichlarini saqlab qolish", isCorrect: true },
      { id: 4, answerText: "Mahsulotlarni tashqi koʼrinishini saqlab qolish", isCorrect: false },
    ],
  },
  {
    questionText: "Og‘zi ochiq idishlarda qaysi jarayon yaxshi o‘tadi?",
    answerOptions: [
      { id: 1, answerText: "Kimyoviy", isCorrect: false },
      { id: 2, answerText: "Fiziologik", isCorrect: true },
      { id: 3, answerText: "Fizik", isCorrect: false },
      { id: 4, answerText: "Mikrobiologik va fizik", isCorrect: false },
    ],
  },
  {
    questionText: "Qadoqlash idishlariga quyiladigan talab qaysi?",
    answerOptions: [
      { id: 1, answerText: "Mahsulotni buzmaslik", isCorrect: false },
      { id: 2, answerText: "Mahsulot sifat ko‘rsatkichlariga ta’sir etmaslik", isCorrect: true },
      { id: 3, answerText: "Mahsulotni boshqa mahsulotga aylantirmaslik", isCorrect: false },
      { id: 4, answerText: "Mahsulot hajmini oshirmaslik", isCorrect: false },
    ],
  },
  {
    questionText: "Antiseptik nima?",
    answerOptions: [
      { id: 1, answerText: "Mahsulot tarkibidagi mikroorganizmlarni rivojlanishini tezlashtiradi", isCorrect: false },
      { id: 2, answerText: "Mahsulot tarkibidagi oqsillarni rivojlanishini to‘xtadi", isCorrect: false },
      { id: 3, answerText: "Mahsulot tarkibidagi mikroorganizmlarni rivojlanishini to‘xtadi", isCorrect: true },
      { id: 4, answerText: "Mahsulot tarkibidagi uglevodlarni rivojlanishini to‘xtadi", isCorrect: false },
    ],
  },
  {
    questionText: "Shisha idishlardagi mahsulotlar buzilmasligi uchun nima qilinadi?",
    answerOptions: [
      { id: 1, answerText: "Salqin joylarga qo‘yiladi", isCorrect: false },
      { id: 2, answerText: "Idishni ichki qismiga material qoplanadi", isCorrect: false },
      { id: 3, answerText: "Idishni rangi o‘zgartiriladi", isCorrect: true },
      { id: 4, answerText: "Kimyoviy ishlov beriladi", isCorrect: false },
    ],
  },
  {
    questionText: "Plastinkali transportyorlar nima maqsadda qo‘llaniladi?",
    answerOptions: [
      { id: 1, answerText: "Bo‘sh va to‘ldirilgan idishlarni, og‘ir yuklarni, issiq materiallarni ko‘chirish maqsadda", isCorrect: true },
      { id: 2, answerText: "Xom ashyo, asosiy va idishlarni ko‘chirish, inspeksiya maqsadda", isCorrect: false },
      { id: 3, answerText: "Bug‘latgichlar, tayyor mahsulotlarni va idishlarni ko‘chirish, inspeksiyalash maqsadda", isCorrect: false },
      { id: 4, answerText: "To‘ldirilgan idishlarni, og‘ir yuklarni, to‘kiluvchan mahsulotlarni ko‘chirish maqsadda", isCorrect: false },
    ],
  },
  {
    questionText: "Shnekli transportyorlar nima maqsadda qo‘llaniladi?",
    answerOptions: [
      { id: 1, answerText: "Qadoqlangan mahsulot idishlarini, yuklarni ko‘chirish, chiqindilarni olib chiqish maqsadda", isCorrect: true },
      { id: 2, answerText: "Xom ashyolar, tayyor mahsulotlar va chiqindilarni olib chiqish maqsadda", isCorrect: false },
      { id: 3, answerText: "Idishlarni ko‘chirish, chiqindilarni olib chiqish maqsadda", isCorrect: false },
      { id: 4, answerText: "Mahsulotlarni ko‘chirish, chiqindilarni olib chiqish maqsadda", isCorrect: false },
    ],
  },
  {
    questionText: "Olma mevalari solinadigan yashik sig‘imi necha kg ni tashkil etadi?",
    answerOptions: [
      { id: 1, answerText: "35-40 kg", isCorrect: false },
      { id: 2, answerText: "26-31 kg", isCorrect: false },
      { id: 3, answerText: "25-30 kg", isCorrect: true },
      { id: 4, answerText: "28-38 kg", isCorrect: false },
    ],
  },
  {
    question: "Xurmo mevalari solinadigan yashik sig‘imi necha kg ni tashkil etadi?",
    answers: [
      { text: "11-17 kg", correct: false },
      { text: "18-20 kg", correct: false },
      { text: "10-15 kg", correct: true },
      { text: "20-25 kg", correct: false }
    ]
  },
  {
    question: "Olmaning qaysi navlarini sifatini buzmasdan uzoq saqlash mumkin?",
    answers: [
      { text: "Toshkent borovinkasi, Red Delishes", correct: false },
      { text: "Toshkent borovinkasi, Jonatan", correct: false },
      { text: "Stark erlist, Janatan", correct: false },
      { text: "Golden Delishes, Renet Simirenko va Rozmarin", correct: true }
    ]
  },
  {
    question: "Bioz nima?",
    answers: [
      { text: "Mahsulotlarni tirik holatida saqlash usuli", correct: true },
      { text: "Mevalarni tuzlab saqlash", correct: false },
      { text: "Quritib saqlash", correct: false },
      { text: "Muzlatib saqlash", correct: false }
    ]
  },
  {
    question: "Psixroanabioz nima?",
    answers: [
      { text: "Quritib", correct: false },
      { text: "Muzlatib", correct: false },
      { text: "Sovutib saqlashga aytiladi", correct: true },
      { text: "Osmotik bosimda", correct: false }
    ]
  },
  {
    question: "Krioanabioz nima?",
    answers: [
      { text: "Quritib", correct: false },
      { text: "Marinadlab", correct: false },
      { text: "Sovutib", correct: false },
      { text: "Muzlatib saqlashga aytiladi", correct: true }
    ]
  },
  {
    question: "Kseroanabioz nima?",
    answers: [
      { text: "Quritib saqlashga aytiladi", correct: true },
      { text: "Sovutib", correct: false },
      { text: "Muzlatib", correct: false },
      { text: "Osmotik bosimda", correct: false }
    ]
  },
  {
    question: "Qand lavlagini saqlayotganda kagatlar qanday balandlikda taxlanadi?",
    answers: [
      { text: "Mexanizasiya yordamida 7-10 metr balanlikda bo’ladi", correct: false },
      { text: "Qo’lda 3-4 metr, mexanizasiya yordamida 5-6 metr balandlikda bo’ladi", correct: true },
      { text: "Qo’lda 1-2 metr", correct: false },
      { text: "Qo’lda 5-6 metr", correct: false }
    ]
  },
  {
    question: "Mevalarning fiziologik yetilishi nima?",
    answers: [
      { text: "fizikaviy, zarur moddalarni to‘planishi", correct: false },
      { text: "biokimyoviy, fizikaviy", correct: false },
      { text: "biokimyoviy jihatdan urug‘lari to‘la yetilishi va zarur oziqa moddalarni to‘planiga aytiladi", correct: true },
      { text: "barglari sargayishi", correct: false }
    ]
  },
  {
    question: "Rezavor mevalarni saqlashda havoning harorati qanday bo‘ladi?",
    answers: [
      { text: "5+6 °C", correct: false },
      { text: "3+7 °C", correct: false },
      { text: "2-3 °C", correct: false },
      { text: "1-2 °C", correct: true }
    ]
  },
  {
    question: "Shaftoli saqlashdagi optimal havo harorati qanday?",
    answers: [
      { text: "2-3 °C", correct: true },
      { text: "5-6 °C", correct: false },
      { text: "7-8 °C", correct: false },
      { text: "8-9 °C", correct: false }
    ]
  },
  {
    questionText: "Havo atmasferasi boshqarilib turiladigan omborlarda mevalarni saqlashda gaz muhiti qanday bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "CO2-15%, O2-5%, N2-95%", isCorrect: false },
      { id: 2, answerText: "CO2-3%, O2-3%, N2-94%", isCorrect: true },
      { id: 3, answerText: "CO2-18%, O2-7%, N2-96%", isCorrect: false },
      { id: 4, answerText: "CO2-10%, O2-12%, N2-98%", isCorrect: false },
    ],
  },
  {
    questionText: "Sovuq zanjir tizimi deganda nimani tushunasiz?",
    answerOptions: [
      { id: 1, answerText: "Hosilni yig‘ishdan iste’molchigacha bulgan bosqichda minimal haroratni ta’minlash", isCorrect: true },
      { id: 2, answerText: "Harorat ketma ketligi", isCorrect: false },
      { id: 3, answerText: "Haroratni oshirib borishi", isCorrect: false },
      { id: 4, answerText: "Mahsulotni vaqti – vaqti bilan sovutish", isCorrect: false },
    ],
  },
  {
    questionText: "Mevalar saqlanadigan omborni fumigatsiya qilish uchun har bir metr kvadratga necha gramm (g)  oltingugurt sarflanadi?",
    answerOptions: [
      { id: 1, answerText: "70-80", isCorrect: false },
      { id: 2, answerText: "90-100", isCorrect: false },
      { id: 3, answerText: "110-120", isCorrect: false },
      { id: 4, answerText: "50-60", isCorrect: true },
    ],
  },
  {
    questionText: "Mevalar sovutgichli kameralarda yaxshi saqlashnishi uchun oyiga necha marta oltingugurt gazi bilan dudlantiriladi?",
    answerOptions: [
      { id: 1, answerText: "2", isCorrect: true },
      { id: 2, answerText: "4", isCorrect: false },
      { id: 3, answerText: "3", isCorrect: false },
      { id: 4, answerText: "5", isCorrect: false },
    ],
  },
  {
    questionText: "Boshqariladigan gaz muhitida mevalar saqlash oddiy usulda saqlashga ko‘ra necha oy ko‘p saqlanadi?",
    answerOptions: [
      { id: 1, answerText: "4-5", isCorrect: false },
      { id: 2, answerText: "3-4", isCorrect: false },
      { id: 3, answerText: "1-2", isCorrect: true },
      { id: 4, answerText: "5-6", isCorrect: false },
    ],
  },
  {
    questionText: "Kagat deganda nimani tushunasiz?",
    answerOptions: [
      { id: 1, answerText: "Keng maydonda mahsulotni saqlash", isCorrect: false },
      { id: 2, answerText: "Qand lavlagini qayta ishlashgacha bo‘lgan davrdagi uyum holdagi saqlash", isCorrect: true },
      { id: 3, answerText: "Yashiklarga joylab saqlash", isCorrect: false },
      { id: 4, answerText: "Er tulalarda saqlash", isCorrect: false },
    ],
  },
  {
    questionText: "Meva-sabzavotlarni pishib etilish fazalari necha bosqichdan iborat?",
    answerOptions: [
      { id: 1, answerText: "Fiziologik, Texniik, Iste’molbop, Terimbop, Biologik etilish", isCorrect: true },
      { id: 2, answerText: "Texnik, biologik va fizologik", isCorrect: false },
      { id: 3, answerText: "Tuliq pishish, va chala pishib etilish", isCorrect: false },
      { id: 4, answerText: "Nimrang, Tuliq, texnik, biologik va fizologik", isCorrect: false },
    ],
  },
  {
    questionText: "Konservalash so‘zining manosi?",
    answerOptions: [
      { id: 1, answerText: "Maydalangan", isCorrect: false },
      { id: 2, answerText: "Pastirlangan", isCorrect: false },
      { id: 3, answerText: "strellangasn", isCorrect: false },
      { id: 4, answerText: "Himoyalangan", isCorrect: true },
    ],
  },
  {
    questionText: "Konservalash necha xil bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "Kimyoviy, fizik va mikrobiologik", isCorrect: true },
      { id: 2, answerText: "Kimyoviy va fizik", isCorrect: false },
      { id: 3, answerText: "Mikrobiologik", isCorrect: false },
      { id: 4, answerText: "Mikrobiologik va fizik", isCorrect: false },
    ],
  },
  {
    questionText: "Mikrobiologik konservalash nimaga asoslanadi?",
    answerOptions: [
      { id: 1, answerText: "Foydali mikroorganizmlar faoliyatini to’xtatishga", isCorrect: false },
      { id: 2, answerText: "Foydali mikroorganizmlar faoliyatini rag’batlantirishga", isCorrect: true },
      { id: 3, answerText: "Sterilizasiya qilishga", isCorrect: false },
      { id: 4, answerText: "Pasterizasiya qilishga", isCorrect: false },
    ],
  },
  {
    questionText: "Qaysi mahsulot qirg’ich yoki elakdan yaxshilab o’tkazilib shakarli siropda qaynatib tayyorlanadi?",
    answerOptions: [
      { id: 1, answerText: "kompot", isCorrect: false },
      { id: 2, answerText: "jem", isCorrect: false },
      { id: 3, answerText: "povidlo", isCorrect: true },
      { id: 4, answerText: "murabbo", isCorrect: false },
    ],
  },
  {
    questionText: "Tomat sharbati tarkibidagi qaysi ferment pektinni parchalab sharbat tarkibidagi etni cho’kishiga olib keladi?",
    answerOptions: [
      { id: 1, answerText: "fruktaza", isCorrect: false },
      { id: 2, answerText: "lipaza", isCorrect: false },
      { id: 3, answerText: "amilaza", isCorrect: false },
      { id: 4, answerText: "pektaza", isCorrect: true },
    ],
  },
  {
    questionText: "Havoning nisbiy namligini aniqlaydigan asbob nima?",
    answerOptions: [
      { id: 1, answerText: "psixometr", isCorrect: true },
      { id: 2, answerText: "termometr", isCorrect: false },
      { id: 3, answerText: "refraktometr", isCorrect: false },
      { id: 4, answerText: "kriometr", isCorrect: false },
    ],
  },
  {
    questionText: "Meva konservalari turlari?",
    answerOptions: [
      { id: 1, answerText: "kampotlar, sharbatlar, murobbolar va marinadlangan mevalar.", isCorrect: true },
      { id: 2, answerText: "kampotlar, asl sabzavot konservalar, gazak konservalar", isCorrect: false },
      { id: 3, answerText: "sharbatlar, gazak konservalar, djem", isCorrect: false },
      { id: 4, answerText: "pavidlo, sabzavot marinadlari, kampotlar", isCorrect: false },
    ],
  },
  {
    questionText: "Sabzavot konservalari turlari?",
    answerOptions: [
      { id: 1, answerText: "Tabiiy sabzavot, gazak sabzavot, pomidor konservalari va marinadlangan sabzavotlar.", isCorrect: true },
      { id: 2, answerText: "Tabiiy sabzavot, gazak sabzavot, sabzavot marinadlari, kampotlar", isCorrect: false },
      { id: 3, answerText: "gazak konservalar, djem, pavidlo, marinadlangan sabzavotlar.", isCorrect: false },
      { id: 4, answerText: "asl sabzavot konservalar, gazak ronservalar, pavidlo, sabzavot marinadlari", isCorrect: false },
    ],
  },
  {
    questionText: "Pamidorni qayta ishlab necha xil mahsulot olinadi?",
    answerOptions: [
      { id: 1, answerText: "sharbat, pyuri(bo‘tqa), tomat pasta(halim), tomat saus(qayla)", isCorrect: true },
      { id: 2, answerText: "sharbat, pyuri(bo‘tqa), tomat sausi(qayla), pavidlo", isCorrect: false },
      { id: 3, answerText: "Sabzavot ikralari, tabiiy sabzavot, tamat pasta(halim), tomat sausi(qayla)", isCorrect: false },
      { id: 4, answerText: "tamat pasta(halim), tomat sausi(qayla), kampotlar, asl sabzavot konservalar", isCorrect: false },
    ],
  },
  {
    questionText: "Sentrifugada sharbatlar qanday tindiriladi?",
    answerOptions: [
      { id: 1, answerText: "O‘z-o‘zidan tindiririladi", isCorrect: false },
      { id: 2, answerText: "markazdan qochma kuchlar ta’sirida", isCorrect: true },
      { id: 3, answerText: "Filtrlardan o‘tkaziladi", isCorrect: false },
      { id: 4, answerText: "Elaklardan o‘tkaziladi", isCorrect: false },
    ],
  },
  {
    questionText: "Vinobop uzum navlaridan qaysilarni bilasiz?",
    answerOptions: [
      { id: 1, answerText: "Bayan-shirey, Saperabi, Aleatiko, Hindagni", isCorrect: true },
      { id: 2, answerText: "Chillaki, Kuldja, Sultoni", isCorrect: false },
      { id: 3, answerText: "Chillaki, Zarafshon kishmishi, Mramor kishmishi,", isCorrect: false },
      { id: 4, answerText: "Katta Qo’rg’on, Shturangur, Rizamat", isCorrect: false },
    ],
  },
  {
    questionText: "Pasterizatsiya nima?",
    answerOptions: [
      { id: 1, answerText: "150 daraja issiqlik bilan ishlov berish", isCorrect: false },
      { id: 2, answerText: "100 daraja issiqlik bilan ishlov berish", isCorrect: false },
      { id: 3, answerText: "120 daraja issiqlik bilan ishlov berish", isCorrect: false },
      { id: 4, answerText: "80-85 daraja issiqlik bilan ishlov berish", isCorrect: true },
    ],
  },
  {
    questionText: "Sterilizatsiya nima?",
    answerOptions: [
      { id: 1, answerText: "100 darajadan yuqori issiqlik bilan ishlov berish", isCorrect: true },
      { id: 2, answerText: "90 daraja issiqlik bilan ishlov berish", isCorrect: false },
      { id: 3, answerText: "75 daraja issiqlik bilan ishlov berish", isCorrect: false },
      { id: 4, answerText: "85 daraja issiqlik bilan ishlov berish", isCorrect: false },
    ],
  },
  {
    questionText: "Sharbat chiqishni ko‘paytirish maqsadida ezilgan mevalar necha daraja haroratda isitiladi?",
    answerOptions: [
      { id: 1, answerText: "70-75 °C", isCorrect: false },
      { id: 2, answerText: "60-70 °C", isCorrect: false },
      { id: 3, answerText: "80-85 °C", isCorrect: true },
      { id: 4, answerText: "90-95 °C", isCorrect: false },
    ],
  },
  {
    questionText: "Uzum sharbatlarining tinishni tezlashtirishda nimalardan foydalaniladi?",
    answerOptions: [
      { id: 1, answerText: "barcha javoblar to‘g‘ri", isCorrect: false },
      { id: 2, answerText: "tuz, shakar, oshlovchi moddalar (jelatin)", isCorrect: false },
      { id: 3, answerText: "olma va limon kislotalari", isCorrect: false },
      { id: 4, answerText: "mog‘or zamburug‘lar, oshlovchi moddalar (jelatin)", isCorrect: true },
    ],
  },
  {
    questionText: "Konservalarni pasterizatsiya qilishda qanday asbobdan foydalaniladi?",
    answerOptions: [
      { id: 1, answerText: "avtoklav", isCorrect: true },
      { id: 2, answerText: "xromatografiya", isCorrect: false },
      { id: 3, answerText: "refraktometr", isCorrect: false },
      { id: 4, answerText: "distilyator", isCorrect: false },
    ],
  },
  {
    questionText: "Etilgan o’rik mevalari tarkibida o’rtacha qand miqdori qancha bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "1-25", isCorrect: false },
      { id: 2, answerText: "30-32", isCorrect: false },
      { id: 3, answerText: "27-29", isCorrect: false },
      { id: 4, answerText: "13-16", isCorrect: true },
      { id: 5, answerText: "3-5", isCorrect: false },
    ],
  },
  {
    questionText: "Doimiy omborlarda sabzavotlar qatlamlari bo’yicha shamollatish va sovutish qanday amalga oshiriladi?",
    answerOptions: [
      { id: 1, answerText: "Tabiiy", isCorrect: false },
      { id: 2, answerText: "Faol", isCorrect: true },
      { id: 3, answerText: "Majburiy", isCorrect: false },
      { id: 4, answerText: "O’z oqimida", isCorrect: false },
      { id: 5, answerText: "Sun’iy", isCorrect: false },
    ],
  },
  {
    questionText: "Sabzi tarkibidagi qand miqdori qancha (%) bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "2-4", isCorrect: false },
      { id: 2, answerText: "-9-10", isCorrect: false },
      { id: 3, answerText: "-5-7", isCorrect: true },
      { id: 4, answerText: "-12", isCorrect: false },
      { id: 5, answerText: "-10-12", isCorrect: false },
    ],
  },
  {
    questionText: "Qulupnoy tarkibidagi organik kislota va qandning miqdori qancha bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "Qand -15,1-20, kislota- 0,8-1,0", isCorrect: true },
      { id: 2, answerText: "Qand -3,5-8,0, kislota- 1,3-3,0", isCorrect: false },
      { id: 3, answerText: "Qand -15-18, kislota- 4,0", isCorrect: false },
      { id: 4, answerText: "Qand -19-22, kislota- 5-6", isCorrect: false },
      { id: 5, answerText: "Qand -6-8, kislota- 3-5", isCorrect: false },
    ],
  },
  {
    questionText: "Xandak va uyumlar qanday tuproq qalinligida ko’miladi (sm)?",
    answerOptions: [
      { id: 1, answerText: "10-15", isCorrect: false },
      { id: 2, answerText: "45-50", isCorrect: true },
      { id: 3, answerText: "20-40", isCorrect: false },
      { id: 4, answerText: "55-60", isCorrect: false },
      { id: 5, answerText: "15-20", isCorrect: false },
    ],
  },
  {
    questionText: "Piyozni o’rtacha hajm og’irligi qancha bo’ladi (kg/m3)?",
    answerOptions: [
      { id: 1, answerText: "250-400", isCorrect: false },
      { id: 2, answerText: "650-700", isCorrect: false },
      { id: 3, answerText: "460-500", isCorrect: false },
      { id: 4, answerText: "560-580", isCorrect: true },
      { id: 5, answerText: "400-450", isCorrect: false },
    ],
  },
  {
    questionText: "Uzum tarkibida qancha organik kislota va qand miqdori bor (%)?",
    answerOptions: [
      { id: 1, answerText: "0,1-1,12 kislota / 10-12 qand", isCorrect: false },
      { id: 2, answerText: "7,0-8,0 kislota / 40-42 qand", isCorrect: false },
      { id: 3, answerText: "4,5-5,0 kislota / 35-39 qand", isCorrect: false },
      { id: 4, answerText: "0,3-2,0 kislota / 16-25 qand", isCorrect: true },
      { id: 5, answerText: "6,0-7,0 kislota / 45-50 qand", isCorrect: false },
    ],
  },
  {
    questionText: "Sabzini o’rtcha hajm og’irligi qancha kg/m2?",
    answerOptions: [
      { id: 1, answerText: "250-300", isCorrect: false },
      { id: 2, answerText: "570-600", isCorrect: true },
      { id: 3, answerText: "350-400", isCorrect: false },
      { id: 4, answerText: "450-500", isCorrect: false },
      { id: 5, answerText: "400-450", isCorrect: false },
    ],
  },
  {
    questionText: "Xandak va uyumlarda qanday shamollatish usuli keng qo’llaniladi?",
    answerOptions: [
      { id: 1, answerText: "tortuvchi", isCorrect: false },
      { id: 2, answerText: "faol", isCorrect: false },
      { id: 3, answerText: "majburiy", isCorrect: false },
      { id: 4, answerText: "o’z-o’zidan", isCorrect: false },
      { id: 5, answerText: "tabiiy", isCorrect: true },
    ],
  },
  {
    questionText: "Karaming o’rtacha hajm og’irligi qancha (kg/m3)?",
    answerOptions: [
      { id: 1, answerText: "450-500", isCorrect: true },
      { id: 2, answerText: "350-400", isCorrect: false },
      { id: 3, answerText: "650-700", isCorrect: false },
      { id: 4, answerText: "750-800", isCorrect: false },
      { id: 5, answerText: "400-450", isCorrect: false },
    ],
  },
  {
    questionText: "Piyozni saqlashda ombordagi havo harorati va nisbiy namligi qanday bo’ladi (issiq saqlash usulida)?",
    answerOptions: [
      { id: 1, answerText: "5 – 6 0C, 80-85 %", isCorrect: false },
      { id: 2, answerText: "12 – 14 0C, 90-95 %", isCorrect: false },
      { id: 3, answerText: "20 – 22 0C, 80-85 %", isCorrect: true },
      { id: 4, answerText: "32 – 34 0C, 70-80 %", isCorrect: false },
      { id: 5, answerText: "4 – 16 0C, 80-85 %", isCorrect: false },
    ],
  },
  {
    questionText: "Mevalarni boshqariladigan gaz muxitida saqlashda qanday solishtirma nisbati yaxshi hisoblanadi?",
    answerOptions: [
      { id: 1, answerText: "O2-12 / CO2-9", isCorrect: true },
      { id: 2, answerText: "O2-14 / CO2-12", isCorrect: false },
      { id: 3, answerText: "O2-15 / CO2-14", isCorrect: false },
      { id: 4, answerText: "O2-20 / CO2-14", isCorrect: false },
      { id: 5, answerText: "O2-18 / CO2-16", isCorrect: false },
    ],
  },
  {
    questionText: "Absolyut chiqindi deb hisoblanayotgan mahsulot qanday bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "Chirigan mahsulot", isCorrect: false },
      { id: 2, answerText: "Mahsulotni ayrim nusxalarini kasalliklar yoki fiziologik qarish natijasida unday mahsulotni hech qaerda ishlatib bo’lmaydi", isCorrect: false },
      { id: 3, answerText: "Tovar navi past mahsulot", isCorrect: false },
      { id: 4, answerText: "Savdoga chiqmaydigan mahsulot", isCorrect: false },
      { id: 5, answerText: "Qayta ishlanmaydigan mahsulot", isCorrect: true },
    ],
  },
  {
    questionText: "Qovunlarni qishki-kuzgi davrda saqlashda omborxonadagi havo harorati va nisbiy namligi qanday bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "0-2 0C, 90-95%", isCorrect: true },
      { id: 2, answerText: "6-8 0C, 90-95%", isCorrect: false },
      { id: 3, answerText: "10-12 0C, 80-90%", isCorrect: false },
      { id: 4, answerText: "15-16 0C, 85-90%", isCorrect: false },
      { id: 5, answerText: "8-10 0C, 90-95%", isCorrect: false },
    ],
  },
  {
    questionText: "Kartoshkani qanday o’lchamdagi uyumlarda saqlanadi?",
    answerOptions: [
      { id: 1, answerText: "2,2-2.4 / 0,2-0,4 / 15-20", isCorrect: false },
      { id: 2, answerText: "1,0-1,2 / 0,0-0,2 / 12-15", isCorrect: true },
      { id: 3, answerText: "2,3-2,5 / 0,3-0,6 / 20-30", isCorrect: false },
      { id: 4, answerText: "2,5-3,0 / 0,3-0,6 / 20-30", isCorrect: false },
      { id: 5, answerText: "1,5-2,0 / 0,6-0,8 / 20-30", isCorrect: false },
    ],
  },
  {
    questionText: "Texnik brak – qanday mahsulot?",
    answerOptions: [
      { id: 1, answerText: "Uringan, pachoqlangan mahsulot", isCorrect: true },
      { id: 2, answerText: "Mahsulotni so’lib qolgani fitopatologik kasallik bilan ayrim qismi zararlanishi. Qayta ishlashga va em sifatida ishlatsa bo’ladi", isCorrect: false },
      { id: 3, answerText: "Eski standart vaqtidan o’tgan mahsulot", isCorrect: false },
      { id: 4, answerText: "Chiriy boshlagan mahsulot", isCorrect: false },
      { id: 5, answerText: "Ishlab o’tib ketgan, et qismi yaroqsiz mahsulot", isCorrect: false },
    ],
  },
  {
    questionText: "Olma mevalarini qish davrida omborxonada saqlashda havo harorati va nisbiy namligi qanday bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "8-10 0C, 75-80%", isCorrect: false },
      { id: 2, answerText: "0,5-1,5 0C, 90-95%", isCorrect: true },
      { id: 3, answerText: "6,8-7 0C, 65-70%", isCorrect: false },
      { id: 4, answerText: "3,5-6 0C, 90-95%", isCorrect: false },
      { id: 5, answerText: "10-12 0C, 85-90%", isCorrect: false },
    ],
  },
  {
    questionText: "Etilmagan limonlarni omborxonada saqlashda havo harorati va nisbiy namligi qanday bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "1-0 0C, 85-90%", isCorrect: false },
      { id: 2, answerText: "6-7 0C, 85-90%", isCorrect: true },
      { id: 3, answerText: "1-2 0C, 90-95%", isCorrect: false },
      { id: 4, answerText: "4-5 0C, 90-95%", isCorrect: false },
      { id: 5, answerText: "-10-12 0C, 85-90%", isCorrect: false },
    ],
  },
  {
    questionText: "Sabzini doimiy omborxonada saqlashda havo harorati va nisbiy namligi qanday bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "Q1Q 20C, 90-95%", isCorrect: true },
      { id: 2, answerText: "-0-1,0 0C, 90-95%", isCorrect: false },
      { id: 3, answerText: "Q3Q 40C, 85-90%", isCorrect: false },
      { id: 4, answerText: "Q1Q 20C, 90-95%", isCorrect: false },
      { id: 5, answerText: "-2-0 0C, 80-85%", isCorrect: false },
    ],
  },
  {
    questionText: "Uzumni yashiklarga joylab omborlarda saqlashda havo harorati va nisbiy namligi qanday bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "4-6 0C, 90-95%", isCorrect: false },
      { id: 2, answerText: "1-2 0C, 90-95%", isCorrect: true },
      { id: 3, answerText: "7-8 0C, 80-85%", isCorrect: false },
      { id: 4, answerText: "-9-10 0C, 80-85%", isCorrect: false },
      { id: 5, answerText: "10-12 0C, 80-90%", isCorrect: false },
    ],
  },
  {
    questionText: "Tarvuzni saqlashda havoning optimal harorati va nisbiy namligi qancha?",
    answerOptions: [
      { id: 1, answerText: "Q6-Q7 0C, 90-95%", isCorrect: false },
      { id: 2, answerText: "Q8-Q10 0C, 85-90%", isCorrect: false },
      { id: 3, answerText: "8-10 0C, 90-95%", isCorrect: false },
      { id: 4, answerText: "Q1-Q4 0C, 85-90%", isCorrect: false },
      { id: 5, answerText: "Q3-Q5 0C, 80-85%", isCorrect: true },
    ],
  },
  {
    questionText: "Yashil va nimbarg pomidorlarni saqlashda harorati va nisbiy namligi qanday bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "0-10 0C, 90-95%", isCorrect: false },
      { id: 2, answerText: "18-20 0C, 80-90%", isCorrect: true },
      { id: 3, answerText: "5-10 0C, 85-90%", isCorrect: false },
      { id: 4, answerText: "12-13 0C, 80-90%", isCorrect: false },
      { id: 5, answerText: "2-10 0C, 85-90%", isCorrect: false },
    ],
  },
  {
    questionText: "Rezavor va danakli mevalarni saqlashda harorati va nisbiy namligi qanday bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "1-2 0C, 90-95%", isCorrect: false },
      { id: 2, answerText: "5-7 0C, 85-90%", isCorrect: false },
      { id: 3, answerText: "3-5 0C, 85-90%", isCorrect: false },
      { id: 4, answerText: "0-10 0C, 90-95%", isCorrect: true },
      { id: 5, answerText: "8-10 0C, 75-80%", isCorrect: false },
    ],
  },
  {
    questionText: "Kartoshkani oziq-ovqat maqsadida qishda saqlashda ombordagi havo optimal harorati va nisbiy namligi qanday bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "8-10 0C, 65-75%", isCorrect: false },
      { id: 2, answerText: "12-14 0C, 85-90%", isCorrect: false },
      { id: 3, answerText: "-2-4 0C, 90-95%", isCorrect: true },
      { id: 4, answerText: "0-1 0C, 90-95%", isCorrect: false },
      { id: 5, answerText: "8-10 0C, 90-95%", isCorrect: false },
    ],
  },
  {
    questionText: "Urug’li kartoshkani qishda saqlashda ombordagi havo harorati va namligi qanday bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "6-7 0C, 85-90%", isCorrect: true },
      { id: 2, answerText: "2-3 0C, 90-95%", isCorrect: false },
      { id: 3, answerText: "4-5 0C, 85-90%", isCorrect: false },
      { id: 4, answerText: "2-3 0C, 90-95%", isCorrect: false },
      { id: 5, answerText: "8-10 0C, 90-95%", isCorrect: false },
    ],
  },
  {
    questionText: "Oshqovoqni qish davrida saqlashda optimal namligi va harorati qanday bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "8-10 0C, 65-75%", isCorrect: false },
      { id: 2, answerText: "12-14 0C, 85-95%", isCorrect: false },
      { id: 3, answerText: "3-8 0C, 90-95%", isCorrect: true },
      { id: 4, answerText: "10-12 0C, 75-80%", isCorrect: false },
      { id: 5, answerText: "16-18 0C, 50-60%", isCorrect: false },
    ],
  },
  {
    questionText: "Sabzi tarkibida o’rtacha vitamin “C” miqdorini aniqlang, mg/%?",
    answerOptions: [
      { id: 1, answerText: "15-20", isCorrect: false },
      { id: 2, answerText: "20-25", isCorrect: false },
      { id: 3, answerText: "20-30", isCorrect: true },
      { id: 4, answerText: "30-35", isCorrect: false },
      { id: 5, answerText: "5-10", isCorrect: false },
    ],
  },
  {
    questionText: "Shaftoli saqlashdagi optimal havo harorati va nisbiy namligi qanday?",
    answerOptions: [
      { id: 1, answerText: "-3-2 0C, 80%", isCorrect: false },
      { id: 2, answerText: "1-2 0C, 85%", isCorrect: true },
      { id: 3, answerText: "2-3 0C, 95%", isCorrect: false },
      { id: 4, answerText: "-1-0 0C, 90%", isCorrect: false },
      { id: 5, answerText: "3-4 0C, 75%", isCorrect: false },
    ],
  },
  {
    questionText: "Kartoshka uchun 450 kg xajmli konteyner o’lchami qanday bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "1,0*1,0*1,0 metr", isCorrect: false },
      { id: 2, answerText: "0,8*0,8*0,8 metr", isCorrect: false },
      { id: 3, answerText: "0,9*0,9*0,9 metr", isCorrect: true },
      { id: 4, answerText: "0,7*0,7*0,7 metr", isCorrect: false },
      { id: 5, answerText: "1,2*1,2*1,2 metr", isCorrect: false },
    ],
  },
  {
    questionText: "Sabzini polietilen qoplarda og’zini ochiq xolda saqlashda harorat va xavoning nisbiy namligi qanday bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "4-5 0C, 75-80%", isCorrect: false },
      { id: 2, answerText: "1-2 0C, 85-95%", isCorrect: false },
      { id: 3, answerText: "-3-4 0C, 70-75%", isCorrect: false },
      { id: 4, answerText: "2-4 0C, 90-95%", isCorrect: true },
      { id: 5, answerText: "0-1 0C, 85-90%", isCorrect: false },
    ],
  },
  {
    questionText: "Piyozning hajmini ko’rsating, kg/m3",
    answerOptions: [
      { id: 1, answerText: "650-700", isCorrect: false },
      { id: 2, answerText: "450-500", isCorrect: false },
      { id: 3, answerText: "700-750", isCorrect: false },
      { id: 4, answerText: "550-600", isCorrect: true },
      { id: 5, answerText: "400-450", isCorrect: false },
    ],
  },
  {
    questionText: "Piyoz boshi qanday haroratda muzlaydi?",
    answerOptions: [
      { id: 1, answerText: "0 0C", isCorrect: false },
      { id: 2, answerText: "1 0C", isCorrect: false },
      { id: 3, answerText: "-3 0C", isCorrect: false },
      { id: 4, answerText: "-2 0C", isCorrect: false },
      { id: 5, answerText: "-4 0C", isCorrect: true },
    ],
  },
  {
    questionText: "Ildiz mevalarni saqlashdagi havoning optimal harorati va nisbiy namligi?",
    answerOptions: [
      { id: 1, answerText: "4-9 0C, 90%", isCorrect: false },
      { id: 2, answerText: "-1-2 0C, 97%", isCorrect: false },
      { id: 3, answerText: "0-10 0C, 95%", isCorrect: true },
      { id: 4, answerText: "4-5 0C, 85%", isCorrect: false },
      { id: 5, answerText: "-3 0C, 90%", isCorrect: false },
    ],
  },
  {
    questionText: "Sarimsoq piyoz oziq-ovqat maqsadida saqlashda optimal havo harorati va nisbiy namligi qanday bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "15-16 0C, 75%", isCorrect: false },
      { id: 2, answerText: "18-20 0C, 70%", isCorrect: true },
      { id: 3, answerText: "22-24 0C, 80%", isCorrect: false },
      { id: 4, answerText: "8-12 0C, 85%", isCorrect: false },
      { id: 5, answerText: "3-4 0C, 86%", isCorrect: false },
    ],
  },
  {
    questionText: "Meva sabzavotlarni vakuum usulida saqlashda polietilen materiallarni qalinligi qancha mikron bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "10-20 mikron", isCorrect: false },
      { id: 2, answerText: "30-40 mikron", isCorrect: false },
      { id: 3, answerText: "30-60 mikron", isCorrect: true },
      { id: 4, answerText: "50-80 mikron", isCorrect: false },
      { id: 5, answerText: "70-100 mikron", isCorrect: false },
    ],
  },
  {
    questionText: "Ko’kat sabzavotlarni saqlashda harorat va havoning nisbiy namligi qanday bo’ladi?",
    answerOptions: [
      { id: 1, answerText: "8-10 0C, 65-75%", isCorrect: false },
      { id: 2, answerText: "1-4 0C, 85-90%", isCorrect: false },
      { id: 3, answerText: "-2-4 0C, 90-95%", isCorrect: false },
      { id: 4, answerText: "0 0C, 90-95%", isCorrect: true },
      { id: 5, answerText: "8-10 0C, 90-95%", isCorrect: false },
    ],
  },
];






